import { useEffect, useState } from "react";

import { copyText } from "../lib/clipboard";
import { ui } from "../lib/ui";

interface CopyButtonProps {
  text: string;
  label?: string;
  className?: string;
  disabled?: boolean;
}

/** Copies `text` to the clipboard and confirms inline for a moment. */
export function CopyButton({
  text,
  label = "Copy path",
  className = ui.btnQuiet,
  disabled,
}: CopyButtonProps) {
  const [state, setState] = useState<"idle" | "copied" | "failed">("idle");

  useEffect(() => {
    if (state === "idle") return;
    const timer = setTimeout(() => setState("idle"), 1800);
    return () => clearTimeout(timer);
  }, [state]);

  const copy = async () => {
    try {
      await copyText(text);
      setState("copied");
    } catch {
      setState("failed");
    }
  };

  return (
    <button
      type="button"
      className={`${className} ${state === "copied" ? ui.btnSelected : ""}`}
      onClick={copy}
      disabled={disabled || !text}
      title={text}
    >
      {state === "copied" ? "Copied ✓" : state === "failed" ? "Copy failed" : label}
    </button>
  );
}
